"use client";

import type { ReactNode } from "react";
import { Button } from "../../Button";
import { Icon } from "../../Icon";
import { Tooltip } from "../../Tooltip";

export interface ChartHintProps {
  /** Interaction help for reading or navigating the chart. */
  children: ReactNode;
  /** Name the chart when several hints appear on one screen. */
  label?: string;
}

/** A compact chart help control using the shared Edges Tooltip. */
export function ChartHint({ children, label = "About this chart" }: ChartHintProps) {
  return (
    <Tooltip content={children} placement="bottom end" openOnPress>
      <Button variant="ghost" size="sm" aria-label={label} className="px-1.5">
        <Icon name="Info" size={16} />
      </Button>
    </Tooltip>
  );
}
